import LeftMenu from 'components/Dashboard/LeftMenu';
import { useMediaQuery } from 'usehooks-ts';
import { NAV_IS_MOBILE_MAX_WIDTH } from 'utils/constants';
import MobileMenu from './MobileMenu';
import { useLocation } from 'react-router-dom';

interface SideNavLayoutProps {
  children: React.ReactNode;
}

/**
 * Pages that draw their own mobile header, with the hamburger in it: the marketplace pages with a
 * search bar, and the root when it renders the marketplace home. Every other page gets the default
 * one, so a new route is never left without the menu.
 */
const OWN_MOBILE_HEADER = [
  '/marketplace/home',
  '/marketplace/category',
  '/marketplace/search',
  '/marketplace/brand',
];

const SideNavLayout = ({ children }: SideNavLayoutProps) => {
  const location = useLocation();
  const isMobile = useMediaQuery(`(max-width: ${NAV_IS_MOBILE_MAX_WIDTH}px)`);
  const showDefaultHeader =
    location.pathname !== '/' &&
    !OWN_MOBILE_HEADER.some((route) => location.pathname.startsWith(route));

  return (
    <>
      {isMobile ? <MobileMenu showDefaultHeader={showDefaultHeader} /> : <LeftMenu />}
      {children}
    </>
  );
};

export default SideNavLayout;
